import * as yup from "yup";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  
const pinCodeRegExp = /^[1-9][0-9]{5}$/;

export const SupplierLocationValidationSchema = yup.object().shape({
  //shipping address
  shippingaddress: yup.string().required("Please enter address."),
  shippingcountry: yup.string().required("Please select country."),
  shippingstate: yup.string().required("Please select state."),
  shippingcity: yup.string().required("Please enter city."),
  shippingpincode: yup
    .string()
    .required("Please enter pincode.")
    .matches(/^(\d{5}|\d{6})$/, "Please enter valid pincode"),
  shippingphone: yup
    .string()
    .required("Please enter mobile number.")
    .matches(phoneRegExp, "Mobile number is not valid.")
    ,
  shippingemail: yup
    .string()
    .email("Email should be valid and contain @")
    .required("Please enter email."),
});
